import { render, staticRenderFns } from "./InlineHoldEdit.vue?vue&type=template&id=5aa4b3bd&scoped=true"
import script from "./InlineHoldEdit.vue?vue&type=script&lang=ts"
export * from "./InlineHoldEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa4b3bd",
  null
  
)

export default component.exports